import { AnyAction, createSlice, Slice } from '@reduxjs/toolkit';
import { TAppDispatch, TState } from '~/src/store';
import { startLoading, stopLoading } from '~/src/store/slices/appSlice';
import { IImage } from '~/src/services/projects';
import { getImages, uploadImage as uploadImageApi } from '~/src/services/projects/projectApi';

interface IImagesSlice {
    list: IImage[];
}

const imagesSlice: Slice<IImagesSlice> = createSlice({
    name: 'images',
    initialState: {
        list: [],
    },
    reducers: {
        update: (state: IImagesSlice, action: AnyAction) => {
            state.list = action.payload;
        },
    },
});

const { actions } = imagesSlice;

export const get = () => {
    return async (dispatch: TAppDispatch, getState: () => TState): Promise<void> => {
        dispatch(startLoading());
        const { auth: { tokenInfo: { token } }, currentProject: { project: { _id: id } } } = getState();

        const resp = await getImages(token, id);
        if (resp.isSuccess === true) {
            dispatch(actions.update(resp.payload));
        }
        dispatch(stopLoading());
    };
};

export const uploadImage = (fieldName: string, file: File) => {
    return async (dispatch: TAppDispatch, getState: () => TState): Promise<void> => {
        const {
            auth: { tokenInfo: { token } },
            currentProject: { project },
            images: { list },
        } = getState();

        const data = await uploadImageApi(token, project._id, file);

        if (data.isSuccess === true) {
            dispatch(actions.update([
                ...list,
                data.payload,
            ]));
        }
    };
};

export const selectImages = (state: TState): IImagesSlice => state.images;

export default imagesSlice.reducer;

